import React from 'react';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { generateSparesSearchUrl } from 'shared/helpers/urls';
import LinkList from 'shared/components/LinkList/LinkList';
import s from './SpareRubricsLinks.css';

class SpareRubricsLinksClass extends React.Component {
  static propTypes = {
    selected: PropTypes.shape(),
    location: PropTypes.shape(),
    rubricsLinks: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        slug: PropTypes.string,
        title: PropTypes.string,
        uk_title: PropTypes.string,
      }),
    ).isRequired,
    isMobile: PropTypes.bool,
    //
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    location: null,
    selected: null,
    isMobile: false,
  };

  buildLink = slug =>
    `/${generateSparesSearchUrl({
      rubric: { slug },
      location: this.props.location,
    })}`;

  render() {
    const { rubricsLinks, isMobile, t, selected } = this.props;
    if (!rubricsLinks || !rubricsLinks.length) {
      return null;
    }
    const title = (
      <h2 style={{ margin: 0 }}>
        {t('SPAREPARTS_RUBRICS_TITLE')}
      </h2>
    );
    let currentSlug = '';
    if (
      selected.sparetype &&
      selected.sparetype.slug &&
      selected.sparetype.parents &&
      selected.sparetype.parents.length &&
      selected.sparetype.parents[0].slug === selected.rubric.slug
    ) {
      currentSlug = `${selected.rubric && selected.rubric.slug
        ? `${selected.rubric.slug}/`
        : ''}${selected.sparetype.slug}`;
    } else if (selected.rubric && selected.rubric.slug) {
      currentSlug = selected.rubric.slug;
    }

    return (
      <div className={s.root}>
        <LinkList
          isMobile={isMobile}
          title={title}
          buildLink={this.buildLink}
          currentSlug={currentSlug}
          list={rubricsLinks}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  selected: searchForm.selected,
  location: globals.location,
});

export const SpareRubricsLinks = withStyles(s)(
  connect(mapStateToProps)(withTranslate(SpareRubricsLinksClass)),
);



// WEBPACK FOOTER //
// ./src/shared/components/SpareRubricsLinks/SpareRubricsLinks.js